// extracted by mini-css-extract-plugin
export default {"icon":"AuthorIcon_icon__SPHIO","fav":"AuthorIcon_fav__Wy7kF"};